import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import {NORMALIZED} from "@constants"
import {normalized} from "@signals"


export const OPTIONS = [
	{ label: 'Normalized', value: NORMALIZED.NORMALIZED },
	{ label: 'Not Normalized', value: NORMALIZED.NOT_NORMALIZED }
]

export default function DIPNormalizedSelect({ ...props }) {
	return <SelectSeeker
		multiple
		options={OPTIONS}
		label="Normalized"
		value={normalized.value}
		onChange={e => normalized.value = e.target.value}
		{...props}
	/>
}